import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-agri-income-return-en-v2',
    templateUrl: './agri-income-return-en-v2.component.html',
    styleUrls: ['./agri-income-return-en-v2.component.css'],
    standalone: false
})
export class AgriIncomeReturnEnV2Component implements OnInit, OnChanges{
  result: number;

  constructor() { }

  @Input() returnData
  @Input() printActive: boolean

  data: any
  agriAvailable:boolean = false

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.returnData?.headSummery?.agricultureSummery?.agricultureSummery
    let netProfitValue = this.data?.netProfit ?? 0;
    let costValue = this.data?.cost ?? 0;
    this.result = netProfitValue - costValue
    this.agriAvailable = this.returnData?.headSummery?.incomeHeadsList?.filter((item)=>item === 'Income from Agriculture')[0] ? true : false        
  }

}
